export const TRIP_RELOAD = 'TRIP_RELOAD';
export const TRIP_RELOADED = 'TRIP_RELOADED';


export function reloadTrip() {
    return {
        type: TRIP_RELOAD
    };
}

export function reloadedTrip() {
    return {
        type: TRIP_RELOADED
    };
}


// WEBPACK FOOTER //
// ./src/actions/trip_actions/index.js